import mapBasic from "./src/main.vue"
mapBasic.install = function (Vue) {
  Vue.component(mapBasic.name, mapBasic)
}
export default mapBasic
